import _ from 'lodash';
import { connect } from 'react-redux';
import { search, remove } from '../../modules/logistics/bulkCustomer';
import { bindActionCreators } from 'redux';
import { showErrors } from '../../modules/general';

const mapStateToProps = state => {

	/** @namespace state.lists.bulkCustomerIds **/
	/** @namespace state.maps.bulkCustomer **/
	/** @namespace state.maps.user **/
	let bulkCustomers = [];
	if (state.lists.bulkCustomerIds) {
		bulkCustomers = _.map(state.lists.bulkCustomerIds, id => state.maps.bulkCustomer[id]);
	}
	const canMakeUpdates = !!(_.get(state.auth.authUser, ['permissions', 'canMakeUpdates'], false));
	return {
		bulkCustomers: _.sortBy(bulkCustomers, 'name'),
		userMap : state.maps.user,
		supplierMap : state.maps.supplier,
		terminalMap : state.maps.terminal,
		stationDeliveryMap : state.maps.stationDelivery,
		carrierMap : state.maps.carrier,
		bulkFormulaMap : state.maps.bulkFormula,
		canMakeUpdates,
		accessToken : state.auth.accessToken, //- used on reporting page
	};
};
const mapDispatchToProps = dispatch => bindActionCreators({
	searchBulkCustomers : search,
	removeBulkCustomer : remove,
	showErrors,
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
);
